import { LayoutRoute } from 'Components/Navigation';
import React from 'react';

export enum FeatureFlags {
  ClientDashboard = 'CLIENT_DASHBOARD_ENABLED',
  V3ReviewerProfile = 'V3_REVIEWER_PROFILE',
  V3UnderReviewQueue = 'V3_UNDER_REVIEW_QUEUE',
  V3Invoices = 'V3_INVOICES',
  V3AllCases = 'V3_ALL_CASES',
  V3ClosedCases = 'V3_CLOSED_CASES',
  V3OpenCases = 'V3_OPEN_CASES',
  V3IntakeQueue = 'V3_INTAKE_QUEUE',
  V3AssigningQueue = 'V3_ASSIGNING_QUEUE',
  V3ReviewerPanelReport = 'V3_REVIEWER_PANEL_REPORT',
}
export const isFeatureEnabled = (flag: FeatureFlags) => {
  const envVar = `REACT_APP_${flag}`;
  const envValue = process.env[envVar];
  const windowValue = (window as Record<string, any>)[`${flag}`];

  if (
    windowValue !== undefined &&
    windowValue !== null &&
    !windowValue.startsWith('#{')
  ) {
    return windowValue.toLowerCase() === 'true';
  }

  return envValue === 'true';
};

export const FeatureFlagProvider: React.FC<{
  children: React.ReactNode;
  flag: FeatureFlags;
}> = ({ children, flag }) => {
  if (isFeatureEnabled(flag)) {
    return <>{children}</>;
  }
  return null;
};

export const FlaggedLayoutRoute: React.FC<{
  flag: FeatureFlags;
  component: React.FC<any>;
  path: string;
  exact?: boolean;
  layoutProps?: any;
}> = ({ flag, component: Cmp, ...rest }) => {
  if (!isFeatureEnabled(flag)) return null;
  return <LayoutRoute {...rest} component={Cmp} />;
};
